(function () {
  function updateLabelWrappers() {
    const labels = document.querySelectorAll(".article-card-label-text");
    labels.forEach((label) => {
      const labelWidth = label.offsetWidth + 40;
      const wrapper = label.closest(".article-card-label-wrapper");
      if (wrapper) {
        wrapper.style.width = `${labelWidth}px`;
      }
    });
  }
  const initHeadingAnimation = (section) => {
    if (!section || !section?.classList.contains("section-blog-posts")) {
      return;
    }
    const enableAnimation = section.querySelector(
      "[data-enable-header-animation]"
    );
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const section = entry.target;
            section.classList.add("anim-active");
            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );
    observer.observe(section);
  };
  updateLabelWrappers();
  initHeadingAnimation(document.currentScript.parentElement);
  document.addEventListener("DOMContentLoaded", updateLabelWrappers);
  window.addEventListener("resize", updateLabelWrappers);
  document.addEventListener("shopify:section:load", (e) => {
    updateLabelWrappers();
    initHeadingAnimation(document.currentScript.parentElement);
  });
})();
